import { ModuleShareNewFormFields } from "../types";

export const processValuesBeforeSubmit = (
  values: ModuleShareNewFormFields
): ModuleShareNewFormFields => {
  const sharedAccounts = values.sharedAccounts
    ?.map((account) => {
      return { value: account.value.trim() };
    })
    .filter((account) => account.value);

  const sharedSpaces = values.sharedSpaces
    ?.map((space) => {
      return { value: space.value.trim() };
    })
    .filter((space) => space.value);

  return {
    ...values,
    sharedAccounts,
    sharedSpaces,
  };
};
